export default __webpack_public_path__ + "static/media/Pos7.d7ad4bd5.svg";